import { inject } from '@angular/core';
import { Router, type ResolveFn } from '@angular/router';
import { Member } from '@features/members/models/member.model';
import { Organization } from '@features/organizations/models/organization.model';
import { OrganizationsService } from '@features/organizations/services/organizations.service';
import { Store } from '@ngxs/store';
import { HideLoadingSite, ShowLoadingSite } from '@stores/site/site.actions';
import { catchError, EMPTY, finalize, mergeMap, Observable, of } from 'rxjs';

export const slugResolver: ResolveFn<any | null> = (
  route,
  state
): Observable<any | null> => {
  const router = inject(Router);
  const orgService = inject(OrganizationsService);
  const store = inject(Store);

  const slug = route.paramMap.get('slug');

  if (!slug) {
    router.navigate(['/not-found']);
    return EMPTY;
  }

  store.dispatch(new ShowLoadingSite());

  return orgService.getPublicOrganization(slug).pipe(
    mergeMap((result) => {
      if (!result) {
        router.navigate(['/not-found']);
        return EMPTY;
      }
      return of(result);
    }),

    finalize(() => setTimeout(() => store.dispatch(new HideLoadingSite()), 2000)),

    catchError((error) => {
      router.navigate(['/not-found']);
      return EMPTY;
    })
  );
};
